import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * Prompt shown when a user cancels out of the New Request / Walk-in wizard after
 * entering vehicle-tab data or beyond. Offers to park the in-progress work as a
 * draft they can resume later, rather than silently discarding it.
 *
 * Three actions:
 *   Save draft   — persist the wizard snapshot as a draft (currentState='draft')
 *   Discard      — throw the work away and leave (existing cancel behavior)
 *   Keep editing — dismiss and stay in the wizard
 *
 * Props:
 *   show          boolean
 *   saving        boolean   — disables buttons + spins the Save action
 *   onSaveDraft   () => void
 *   onDiscard     () => void
 *   onKeepEditing () => void
 */
const SaveDraftModal = ({
  show,
  saving = false,
  onSaveDraft,
  onDiscard,
  onKeepEditing,
}) => (
  <Modal show={show} onHide={saving ? undefined : onKeepEditing} centered>
    <Modal.Header closeButton={!saving}>
      <Modal.Title>Save as draft?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        You have unsaved work on this request. Save it as a draft to pick up right
        where you left off — nothing is submitted and it won't affect your counts.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="link" className="text-danger" onClick={onDiscard} disabled={saving}>
        Discard
      </Button>
      <Button variant="secondary" onClick={onKeepEditing} disabled={saving}>
        Keep editing
      </Button>
      <Button variant="primary" onClick={onSaveDraft} disabled={saving}>
        {saving ? (
          <span>
            <i className="fa-sharp fa-regular fa-spinner fa-spin" /> Saving…
          </span>
        ) : (
          <span>Save draft</span>
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SaveDraftModal;
